// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"440":"7f98bc38","551":"21c10c4e","828":"76a166f1","851":"aec0bc19"}[chunkId] + ".chunk.js";
};